import { Building2, User } from 'lucide-react'
import type { AccountType } from './SignupTypeSelectionScreen'

interface SignupTypeSelectionScreenMobileProps {
  onSelect: (accountType: AccountType) => void
}

export const SignupTypeSelectionScreenMobile = ({ onSelect }: SignupTypeSelectionScreenMobileProps) => {
  return (
    <div className="min-h-screen bg-white p-4">
      <div className="max-w-md mx-auto space-y-6 pt-12">
        <div className="text-center">
          <h1 className="font-plus-jakarta text-[24px] font-medium leading-[32px] text-[#2d2923]">
            Choose Your Account Type
          </h1>
          <p className="font-plus-jakarta text-[14px] font-normal leading-[20px] text-[rgba(45,41,35,0.64)] mt-2">
            Select the type of account you'd like to create
          </p>
        </div>

        <div className="space-y-4">
          {/* Individual Account */}
          <button
            type="button"
            onClick={() => onSelect('individual')}
            className="w-full flex items-center gap-4 p-6 border-2 border-[rgba(45,41,35,0.12)] bg-[rgba(255,255,255,0.72)] hover:border-[rgba(45,41,35,0.32)] hover:bg-[rgba(255,255,255,0.9)] transition-all cursor-pointer rounded-none"
          >
            <div className="w-12 h-12 rounded-full bg-[rgba(45,41,35,0.08)] flex items-center justify-center flex-shrink-0">
              <User className="w-6 h-6 text-[#2d2923]" />
            </div>
            <div className="text-left flex-1">
              <h3 className="font-plus-jakarta text-[18px] font-medium leading-[24px] text-[#2d2923] mb-1">
                Individual
              </h3>
              <p className="font-plus-jakarta text-[13px] font-normal leading-[18px] text-[rgba(45,41,35,0.72)]">
                For personal investment accounts
              </p>
            </div>
          </button>

          {/* Institution Account */}
          <button
            type="button"
            onClick={() => onSelect('institution')}
            className="w-full flex items-center gap-4 p-6 border-2 border-[rgba(45,41,35,0.12)] bg-[rgba(255,255,255,0.72)] hover:border-[rgba(45,41,35,0.32)] hover:bg-[rgba(255,255,255,0.9)] transition-all cursor-pointer rounded-none"
          >
            <div className="w-12 h-12 rounded-full bg-[rgba(45,41,35,0.08)] flex items-center justify-center flex-shrink-0">
              <Building2 className="w-6 h-6 text-[#2d2923]" />
            </div>
            <div className="text-left flex-1">
              <h3 className="font-plus-jakarta text-[18px] font-medium leading-[24px] text-[#2d2923] mb-1">
                Institution
              </h3>
              <p className="font-plus-jakarta text-[13px] font-normal leading-[18px] text-[rgba(45,41,35,0.72)]">
                For institutional and corporate accounts
              </p>
            </div>
          </button>
        </div>
      </div>
    </div>
  )
}
